import React from 'react'
import styles from './ProductFilterActiveCount.module.scss'

type Props = {
  count: number
}

const ProductFilterActiveCount: React.FC<Props> = (props: Props) => {
  return <div className={styles['product-filter-active-count__container']}>{props.count}</div>
}

export default ProductFilterActiveCount
